/* (ignored) */


//////////////////
// WEBPACK FOOTER
// chalk (ignored)
// module id = 2
// module chunks = 0 1